<!--  -->
<template>
  <div class="container">
    <img
            :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/fetal-monitor/register.png?t=' + Date.now()"
      alt="超声多普勒胎儿监护仪注册证"
      v-if="pageType == 0"
    />
    <img
            :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/Multiple-signs.jpg?t=' + Date.now()"
      alt="多体征注册证"
      v-if="pageType == 1"
    />
    <img
            :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/ovulation/1.png?t=' + Date.now()"
      alt="排卵试纸注册证"
      v-if="pageType == 2"
    />
     <img
            :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/ovulation/2.png?t=' + Date.now()"
      alt="排卵试纸注册证"
      v-if="pageType == 2"
    />
    <img
            :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/ovulation/3.png?t=' + Date.now()"
      alt="排卵试纸注册证"
      v-if="pageType == 2"
    />
     <img
            :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/ovulation/4.png?t=' + Date.now()"
      alt="排卵试纸注册证"
      v-if="pageType == 2"
    />
    <img
            :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/ovulation/5.png?t=' + Date.now()"
      alt="排卵试纸注册证"
      v-if="pageType == 2"
    />
     <img
            :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/ovulation/6.png?t=' + Date.now()"
      alt="排卵试纸注册证"
      v-if="pageType == 2"
    />
  </div> 
</template>

<script>
export default {
  name: "",
  data() {
    return {
      pageType: 0
    };
  },

  props: [],

  watch: {},

  components: {},

  computed: {},

  created() {
    if (this.$route.query.pageType) {
      this.pageType = this.$route.query.pageType;
    }
  },

  methods: {}
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 30px;

  img {
    max-width:80vw; 

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/license/register.vue